const colorsPalette = {
  // DARKS TODO: deprecate and use greys
  dark10: '#20303C',
  dark20: '#43515C',
  dark30: '#66737C',
  dark40: '#858F96',
  dark50: '#A3ABB0',
  dark60: '#C2C7CB',
  dark70: '#E0E3E5',
  dark80: '#F2F4F5',
  // GREYS
  grey10: '#20303C',
  grey20: '#4D5963',
  grey30: '#79838A',
  grey40: '#A6ACB1',
  grey50: '#D2D6D8',
  grey60: '#E8ECF0',
  grey70: '#F0F4F7',
  grey80: '#F8f9FA',
  // BLUES
  blue10: '#0097C3',
  blue20: '#00A8DA',
  blue30: '#00BBF2',
  blue40: '#40CCF6',
  blue50: '#85DFF9',
  blue60: '#B2EAFB',
  blue70: '#CFF3FD',
  blue80: '#E3F8FE',
  // CYAN,
  cyan10: '#00AAAF',
  cyan20: '#32BABC',
  cyan30: '#3CC7C5',
  cyan40: '#64D4D2',
  cyan50: '#8BDFDD',
  cyan60: '#B1E9E9',
  cyan70: '#D8F4F4',
  cyan80: '#EBF9F9',
  // GREENS
  green10: '#00A36F',
  green20: '#00B47A',
  green30: '#00CD8B',
  green40: '#45DBAA',
  green50: '#87E7C8',
  green60: '#B2F0DC',
  green70: '#CFF6E9',
  green80: '#E3FAF2',
  // YELLOWS
  yellow10: '#E19800',
  yellow20: '#F0A700',
  yellow30: '#FFB600',
  yellow40: '#FFCA45',
  yellow50: '#FFDD87',
  yellow60: '#FFEAB5',
  yellow70: '#FFF2D1',
  yellow80: '#FFF7E3',
  // ORANGE,
  orange10: '#D9644A',
  orange20: '#E66A4E',
  orange30: '#F27052',
  orange40: '#F37E63',
  orange50: '#F7A997',
  orange60: '#FAC6BA',
  orange70: '#FCE2DC',
  orange80: '#FEF0ED',
  // REDS
  red10: '#D72E15',
  red20: '#EB4229',
  red30: '#FF563D',
  red40: '#FF8472',
  red50: '#FFB2A6',
  red60: '#FFD0C9',
  red70: '#FFE3DE',
  red80: '#FFF0ED',
  // PURPLE,
  purple10: '#8B1079',
  purple20: '#A0138E',
  purple30: '#B13DAC',
  purple40: '#C164BD',
  purple50: '#D08BCD',
  purple60: '#E0B1DE',
  purple70: '#EFD8EE',
  purple80: '#F7EBF7',
  // VIOLETS
  violet10: '#3022D0',
  violet20: '#4434EB',
  violet30: '#5847FF',
  violet40: '#8579FF',
  violet50: '#B2ABFF',
  violet60: '#D1CCFF',
  violet70: '#E3E0FF',
  violet80: '#F0EEFF',
  // WHITE,
  white: '#FFFFFF',
  black: '#000000'
};

// For Eslint --fix
const extraFixColorsMap = {
  black: 'black',
  white: 'white',
  '#000': 'black',
  '#fff': 'white'
};

const themeColors = {
  primary: colorsPalette.blue30
}

export {
  colorsPalette,
  themeColors,
  extraFixColorsMap
};
